export default {
    dependencies: ['$element', 'trackingservice', 'radio'],
    callable(ele, trackingservice, radio) {
        ele
            .querySelector('[data-extended-profile-link]')
            .addEventListener('click', trackClick);
        ele.addEventListener('click', event => event.stopPropagation());
        radio('main-image-carousel-navigate').subscribe((index, ele) => {
            if (ele.closest('[data-extended-profile]')) {
                trackShow();
            }
        });

        function trackShow() {
            trackingservice.trackEvent(
                'promotions.traffic-to-partnersite-from-gallery.show'
            );
        }

        function trackClick() {
            trackingservice.trackEvent(
                'promotions.traffic-to-partnersite-from-gallery.click'
            );
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/trackExtendedProfile.js